import { useTranslation } from 'react-i18next';

import { FeatureGroupData } from './data';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselKizeoFeatureGroupDots,
} from '@/components/ui/carousel';

const Card = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className={`w-full max-w-[250px] md:max-w-[230px] 3xl:max-w-[300px] md:w-[230px] 3xl:w-[300px] min-w-[250px] md:min-w-[230px] h-[250px] md:h-[230px] 3xl:h-[300px] p-6 rounded-2xl bg-transparent border border-gray-300`}
    >
      {children}
    </div>
  );
};

const FeatureGroup = ({ displayName, features }: FeatureGroupData) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 3xl:gap-4">
      <h2 className="text-lg 3xl:text-xl font-medium text-center md:text-left">
        {t(displayName)}
      </h2>

      {/* Desktop */}
      <div className="hidden md:flex justify-center gap-2 3xl:gap-4">
        {features.map((feature) => (
          <Card key={feature.title}>
            <div className="text-primary scale-100 3xl:scale-125 max-w-fit">
              {feature.icon}
            </div>
            <p className="font-medium pt-3 pb-1 3xl:pb-3 3xl:text-lg">
              {t(feature.title)}
            </p>
            <p className="text-[#545964] text-sm 3xl:text-base">
              {t(feature.description)}
            </p>
          </Card>
        ))}
      </div>

      {/* Mobile/Tablet: Carousel */}
      <div className="md:hidden mt-4">
        <Carousel
          opts={{
            align: 'start',
            loop: false,
            slidesToScroll: 1,
            containScroll: 'trimSnaps',
          }}
          className="w-full"
        >
          <CarouselContent className="-ml-2 pl-4">
            {features.map((feature) => (
              <CarouselItem key={feature.title} className="pl-2 basis-auto">
                <Card>
                  <div className="text-primary scale-100 max-w-fit">
                    {feature.icon}
                  </div>
                  <p className="font-medium pt-3 pb-1 text-base">
                    {t(feature.title)}
                  </p>
                  <p className="text-[#545964] text-sm leading-6">
                    {t(feature.description)}
                  </p>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>

          <CarouselKizeoFeatureGroupDots />
        </Carousel>
      </div>
    </div>
  );
};

export { FeatureGroup };
